import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class VerifyAccountService {

    constructor(
        private _http: HttpClient
    ) { }

    verifyAccountAndSetPassword(obj) {
        return this._http.post(environment.serverUrl + '/user/verifyAccountAndSetPassword', obj);
    }

    isCodeValid(code) {
        return this._http.get(environment.serverUrl + '/isCodeValid/' + code);
    }
}



// WEBPACK FOOTER //
// ./src/app/verify-account/verify-account.service.ts